import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { useAlertStore } from '../stores/alert';

export default /*@__PURE__*/_defineComponent({
  __name: 'AlertPop',
  setup(__props) {


const alertStore = useAlertStore();


return (_ctx: any,_cache: any) => {
  return (_unref(alertStore).alert)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["alert", `alert-${_unref(alertStore).alert.type}`])
      }, [
        _createTextVNode(_toDisplayString(_unref(alertStore).alert.message) + " ", 1),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(alertStore).clear()))
        }, "×")
      ], 2))
    : _createCommentVNode("", true)
}
}

})